import { render, staticRenderFns } from "./refuseRequest.vue?vue&type=template&id=12bc5bfb&scoped=true"
import script from "./refuseRequest.vue?vue&type=script&lang=js"
export * from "./refuseRequest.vue?vue&type=script&lang=js"
import style0 from "./refuseRequest.vue?vue&type=style&index=0&id=12bc5bfb&lang=scss&scoped=true"
import style1 from "./refuseRequest.vue?vue&type=style&index=1&id=12bc5bfb&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc5bfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12bc5bfb')) {
      api.createRecord('12bc5bfb', component.options)
    } else {
      api.reload('12bc5bfb', component.options)
    }
    module.hot.accept("./refuseRequest.vue?vue&type=template&id=12bc5bfb&scoped=true", function () {
      api.rerender('12bc5bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/refuseRequest.vue"
export default component.exports